import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

export function useAuthSession() {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon, obj=logged in
  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/auth/me`);
      setUser(r.data);
    } catch {
      setUser(null);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { user, setUser, refresh };
}